import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { CommonAuthService } from 'app/auth/common-auth.service';

@Component({
  selector: 'app-welcome-layout-arabic',
  templateUrl: './welcome-layout-arabic.component.html',
  styleUrls: ['./welcome-layout-arabic.component.scss']
})
export class WelcomeLayoutArabicComponent implements OnInit {
  postList: Array<any> = [];

  constructor(private route: ActivatedRoute,private auth:CommonAuthService) { }

  ngOnInit() {
    this.auth.getLastThree().subscribe(res=>{
      this.postList=res['Post']
      //console.log(res['Post'])
    },err=>{
      //console.log('error')
    })
  }
open(id)
{
  //console.log(id);
}
}
